module.exports = __webpack_public_path__ + "assets/img/img76.b97a3249.png";